<template>
  <div class="pa-4">
    <v-title>
      <span class="title">NBN Hardware</span>
    </v-title>
    <v-container grid-list-md>
      <v-layout wrap class="pt-3">
        <div>
          <v-btn class="primary mt-2" @click="dialog = true">Add New</v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-flex lg4>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex lg2>
          <v-checkbox
            v-model="showArchived"
            class="mx-3"
            name="showArchived"
            label="Show Archived"
          ></v-checkbox>
        </v-flex>
      </v-layout>
    </v-container>

    <v-data-table
      :items="filteredBundles"
      :search="search"
      :loading="loading"
      :headers="headers"
      item-key="id"
      :pagination.sync="pagination"
    >
      <template v-slot:items="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.hardwareName }}</td>
        <td>{{ props.item.contractLength }}</td>
        <td>{{ props.item.usageType }}</td>
        <td>{{ props.item.detail }}</td>
        <td>${{ props.item.rrp || 0 }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="editDetails(props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="onDeleteHardware(props.item)">
            <v-icon v-if="!props.item.archive" color="pink">delete</v-icon>
            <v-icon v-else color="success">refresh</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <v-snackbar v-model="snackbar" :timeout="1000">
      {{ message }}
    </v-snackbar>
    <v-dialog max-width="800px" v-model="dialog" persistent>
      <upsertNbnHardware
        :isEdit="isEdit"
        :hardware="hardware"
        @close="closeDialog"
        @save="onSave"
      ></upsertNbnHardware>
    </v-dialog>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { createNamespacedHelpers } from 'vuex';
import { mapNbnHardwareFields } from '@/store/modules/forms/nbnHardware';
const { mapActions: mapPbxDomainsActions } = createNamespacedHelpers(
  'nbnHardware'
);
import { NBNHardware } from '@/models/NbnHardware';
import upsertNbnHardware from './upsert-nbn-hardware.vue';

export default {
  name: 'BundleManagement',
  components: {
    ValidationProvider,
    upsertNbnHardware,
  },
  data() {
    return {
      search: '',
      loading: true,
      rows: [],
      type: [
        'nbn',
        'nbnEnterprise',
        'mobile',
        'hardware',
        'hwbb',
        'fiveG',
        'teams',
      ],
      pagination: {
        page: 1,
        rowsPerPage: 20,
        totalItems: 0,
      },
      headers: [
        {
          text: 'Id',
          align: 'left',
          sortable: true,
          value: 'bundleId',
        },
        {
          text: 'Hardware Name',
          align: 'left',
          value: 'bundleName',
        },
        {
          text: 'Contract Length',
          align: 'left',
          sortable: true,
          value: 'contractMonths',
        },
        {
          text: 'Usage Type',
          align: 'left',
          sortable: true,
          value: 'usageType',
        },
        {
          text: 'Detail',
          align: 'left',
          sortable: false,
          value: 'detail',
        },

        {
          text: 'RRP ',
          align: 'left',
          sortable: true,
          value: 'rrpInc',
        },
        {
          text: 'Actions',
          align: 'left',
          sortable: false,
          value: 'actions',
        },
      ],
      snackbar: false,
      showArchived: false,
      hardware: new NBNHardware(),
      isEdit: false,
      dialog: false,
    };
  },
  watch: {
    showArchived: function() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    editDetails(item) {
      this.isEdit = true;
      this.hardware = { ...item };
      this.dialog = true;
    },

    onDeleteHardware(item) {
      const payload = { ...item, archive: !item.archive };
      this.$dialog
        .confirm(
          `Are you sure you want to ${item.archive ? 'restore' : 'delete'}?`
        )
        .then(async () => {
          (this.loading = true),
            this.$store
              .dispatch('nbnHardware/upsertNBNHardware', payload)
              .then(data => {
                this.loading = false;
                this.$store
                  .dispatch('nbnHardware/deleteNbnHardware', data.id)
                  .then(e => {
                    this.init();
                  });
              });
        })
        .catch(() => {});
    },
    onSave(payload) {
      this.$store.dispatch('nbnHardware/upsertNBNHardware', payload).then(_ => {
        this.loading = false;
        this.init();
        this.dialog = false;
      });
    },
    init() {
      this.loading = true;
      this.$store
        .dispatch('nbnHardware/getNBNHardwares', this.showArchived)
        .then(data => {
          this.rows = data;
        });
      this.loading = false;
    },
    closeDialog() {
      this.dialog = false;
      this.isEdit = false;
      this.hardware = new NBNHardware();
    },
  },
  computed: {
    ...mapNbnHardwareFields(['message']),
    filteredBundles() {
      let vm = this;
      return vm.rows.filter(e => {
        if (!vm.search) {
          return true;
        }
        return (
          e.hardwareName.includes(vm.search) ||
          e.hardwareName.includes(vm.search) ||
          e.usageType.includes(vm.search)
        );
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
